module.exports = __webpack_public_path__ + "img/高老庄.1a1effd2.png";